import { LegacyCard, RadioButton, Stack } from "@shopify/polaris";
import React, { FC, useCallback } from "react";
import { FieldRenderProps } from "react-final-form";
import {
  SELECT_PRODUCTS_BASED_ON_DOES_NOT_HAVE_ATTRIBUTE,
  SELECT_PRODUCTS_BASED_ON_DOES_NOT_HAVE_TAG,
  SELECT_PRODUCTS_BASED_ON_HAVE_ATTRIBUTE,
  SELECT_PRODUCTS_BASED_ON_HAVE_TAG,
  SELECT_PRODUCTS_BASED_ON_MULTIPLE_CONDITIONS
} from "../../../../../../../../constants/selectProductsBasedOn.js";

interface SelectVariantCardProps extends FieldRenderProps<any> {
}

const SelectVariantCard: FC<SelectVariantCardProps> = ({ input, setFilterValues }) => {
  const handleChange = useCallback((_checked, newValue) => {
    input.onChange(newValue);
  }, [input]);

  return (
    <LegacyCard sectioned>
      <Stack vertical spacing={"extraTight"}>
        <RadioButton
          id={SELECT_PRODUCTS_BASED_ON_DOES_NOT_HAVE_ATTRIBUTE}
          label="Has a missing attribute"
          checked={input.value === SELECT_PRODUCTS_BASED_ON_DOES_NOT_HAVE_ATTRIBUTE}
          name="productBy"
          onChange={handleChange}
        />
        <RadioButton
          id={SELECT_PRODUCTS_BASED_ON_DOES_NOT_HAVE_TAG}
          label="Does not have a specific tag"
          name="productBy"
          checked={input.value === SELECT_PRODUCTS_BASED_ON_DOES_NOT_HAVE_TAG}
          onChange={handleChange}
        />
        <RadioButton
          id={SELECT_PRODUCTS_BASED_ON_HAVE_TAG}
          label="Has a specific tag"
          name="productBy"
          checked={input.value === SELECT_PRODUCTS_BASED_ON_HAVE_TAG}
          onChange={handleChange}
        />
        <RadioButton
          id={SELECT_PRODUCTS_BASED_ON_HAVE_ATTRIBUTE}
          label="Has a specific attribute"
          name="productBy"
          checked={input.value === SELECT_PRODUCTS_BASED_ON_HAVE_ATTRIBUTE}
          onChange={handleChange}
        />
        <RadioButton
          id={SELECT_PRODUCTS_BASED_ON_MULTIPLE_CONDITIONS}
          label="Multiple conditions"
          name="productBy"
          checked={input.value === SELECT_PRODUCTS_BASED_ON_MULTIPLE_CONDITIONS}
          onChange={handleChange}
        />
      </Stack>
    </LegacyCard>

  );
};

export default SelectVariantCard;